<div class="sources-location-container">
  <mat-selection-list
    disableRipple="true"
    class="listGeography"
    [formControl]="geographyControl"
  >
    <h3 matSubheader>Sources location</h3>
    <form [formGroup]="geographyForm" (click)="$event.stopPropagation()">
      <mat-form-field>
        <input
          type="text"
          matInput
          placeholder="Search..."
          formControlName="geographyGroup"
          [matAutocomplete]="autoGroup"
        />
        <mat-autocomplete class="distinct-panel" #autoGroup="matAutocomplete">
          <mat-optgroup
            *ngFor="let group of geographyGroupOptions | async"
            [label]="group.type"
          >
            <mat-option
              *ngFor="let name of group.names"
              [value]="name"
              (click)="search.emit({ name: name, type: group.type })"
            >
              {{ name }}
            </mat-option>
          </mat-optgroup>
        </mat-autocomplete>
      </mat-form-field>
    </form>
    <ng-container *ngFor="let continent of geography.continents">
      <mat-list-option
        *ngIf="continent.selected"
        [class.active]="continent.selected"
        [value]="continent.value"
        (click)="$event.stopPropagation(); toggleOption.emit(continent)"
        class="pendo-continent-option"
      >
        <div class="filter-text">
          <span>{{ continent.label }}</span>
        </div>
      </mat-list-option>
    </ng-container>
    <ng-container *ngFor="let country of geography.countries">
      <mat-list-option
        *ngIf="country.selected"
        [class.active]="country.selected"
        [value]="country.value"
        (click)="$event.stopPropagation(); toggleOption.emit(country)"
        class="pendo-country-option"
      >
        <div class="filter-text">
          <span>{{ country.label }}</span>
        </div>
      </mat-list-option>
    </ng-container>
    <ng-container
      *ngFor="let continent of geography.continents | orderBy: 'label'"
    >
      <mat-list-option
        *ngIf="!continent.selected"
        [class.active]="continent.selected"
        [value]="continent.value"
        (click)="$event.stopPropagation(); toggleOption.emit(continent)"
        class="pendo-continent-option"
      >
        <div class="filter-text">
          <span>{{ continent.label }}</span>
        </div>
      </mat-list-option>
    </ng-container>
    <ng-container
      *ngFor="let country of geography.countries | orderBy: 'label'"
    >
      <mat-list-option
        *ngIf="!country.selected"
        [class.active]="country.selected"
        [value]="country.value"
        class="pendo-country-option"
        (click)="$event.stopPropagation(); toggleOption.emit(country)"
      >
        <div class="filter-text">
          <span>{{ country.label }}</span>
        </div>
      </mat-list-option>
    </ng-container>
  </mat-selection-list>
</div>

<div class="sources-panels-container">
  <mat-selection-list
    disableRipple="true"
    class="listPanels"
    [formControl]="panelsControl"
  >
    <h3 matSubheader>Sources Panels</h3>
    <mat-list-option
      *ngFor="let panel of panels"
      [value]="panel.value"
      (click)="$event.stopPropagation(); toggleOption.emit(panel)"
      class="pendo-panel-option"
    >
      <div class="filter-text">
        <span style="text-transform: capitalize">{{ panel.label }}</span>
      </div>
    </mat-list-option>
  </mat-selection-list>
</div>
